import Vue from 'vue'
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
    config: { id: 'G-E2EME0Q7K7' }
});
